import script from "./EcommerceServices.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceServices.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceServices.vue?vue&type=style&index=0&id=355ee530&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-355ee530"]])

export default __exports__